
var ResourceHelpers = {};

module.exports = ResourceHelpers;

ResourceHelpers.getMostRecentSavepoint = function(resource, types){
	if(!resource.save_points) return -1;
    let savePoints = resource.save_points;
    let versionPicked = false;
    return savePoints.reduceRight( (accum, savepoint) => {
        if(!versionPicked && types.indexOf(savepoint.type) != -1){
            accum = savepoint;
            versionPicked = true;
        }
        return accum;
    }, -1);
}

ResourceHelpers.shouldMigrateCollabDoc = function(resource){
    if(!resource.sharejs_id) return false;

    var savepoint = ResourceHelpers.getMostRecentSavepoint(resource, ["savedSnapshot", "draft"]);

    if(savepoint != -1 && savepoint && savepoint.time && (new Date(resource.updated_at)) <= (new Date(savepoint.time))) return false;
    for(var i = 0; i < resource.save_points.length; i++){
        if(resource.save_points[i].type == 'draft' || resource.save_points[i].not_from_sharejs)
            return false;
    }
    return true;
}
